const ROUTE_LOGIN = "/pages/login/Login";
const ROUTE_REGISTER = "/pages/register/Register";
const ROUTE_FORGOT_PASSWORD = "/pages/forgotPassword/ForgotPassword";
const ROUTE_HOME = "/pages/home/Home";
const ROUTE_ALL_NEWS = "/pages/news/AllNews";
const ROUTE_NEWS_DETAILS = "/pages/news/NewsDetails";
const ROUTE_QUOTES = "/pages/quotes/Quotes";
const ROUTE_SEARCH_QUOTES = "/pages/quotes/SearchQuotes";
const ROUTE_QUOTES_DETAILS = "/pages/quotes/QuotesDetails";
const ROUTE_TIME_BAO = "/pages/user/timebao/TimeBao";
const ROUTE_PROTOCOL = "/pages/protocol/Protocol";
const ROUTE_TIME_BAO_DETAILS = "/pages/user/timebao/TimeBaoDetails";
const ROUTE_CAPITAL = "/pages/capital/CapitalAccount";
const ROUTE_FOUND_WINNER = "/pages/foundWinner/FoundWinner";
const ROUTE_FUND_DETAILS = "/pages/capital/CapitalFundDetails";
const ROUTE_ACTIVITY_LIST = "/pages/activity/activity";
const ROUTE_ACTIVITY_DETAIL = "/pages/activity/ActivityDetail";
const ROUTE_CAPITAL_ACCOUNT_DETAILS = "/pages/capital/CapitalAccountDetails";
const ROUTE_INCREASE_INFO = "/pages/capital/IncreaseInfo";
const ROUTE_ACCOUNT = "/pages/user/account/Account";
const ROUTE_RECHARGE = "/pages/user/recharge/Recharge";
const ROUTE_RECHARGE_INFO_1 = "/pages/user/recharge/RechargeInfo_1";
const ROUTE_RECHARGE_INFO_2 = "/pages/user/recharge/RechargeInfo_2";
const ROUTE_RECHARGE_INFO_3 = "/pages/user/recharge/RechargeInfo_3";
const ROUTE_WITHDRAW = "/pages/user/withdraw/Withdraw";
const ROUTE_KLINE = "/pages/kline/Kline";
const ROUTE_TRADING = "/pages/trading/Trading";
const ROUTE_TRADING_DIRECTION = "/pages/trading/TradingDirection";
const ROUTE_CLOSED_CAPITAL_INFO = "/pages/capital/ClosedCapitalInfo";
const ROUTE_ANNOUNCEMENT = "/pages/user/announcement/Announcement";
const ROUTE_ANNOUNCEMENT_DETAIL = "/pages/user/announcement/AnnouncementDetail";
const ROUTE_MEMBER_INFORMATION = "/pages/user/memberInformation/MemberInformation";
const ROUTE_MEMBER_DETAILED_LOG = "/pages/user/memberInformation/MemberDetailedLog";
const ROUTE_POSITION_INQUIRY = "/pages/user/inquiry/PositionInquiry";
const ROUTE_DEAL_INQUIRY = "/pages/user/inquiry/DealInquiry";
const ROUTE_ENTRUST_INQUIRY = "/pages/user/inquiry/EntrustInquiry";
const ROUTE_WITHDRAWAL_INQUIRY = "/pages/user/inquiry/WithdrawalInquiry";
const ROUTE_ABOUT_US = "/pages/aboutus/aboutusdetails";
const ROUTE_RISK_CONTROL = "/pages/user/riskControl/RiskControl";
const ROUTE_MODIFY_NICKNAME = "/pages/user/memberInformation/update/ModifyNickname";
const ROUTE_MODIFY_REALNAME = "/pages/user/memberInformation/update/ModifyRealname";
const ROUTE_MODIFY_BANK = "/pages/user/memberInformation/update/ModifyBank";
const ROUTE_MODIFY_PHONE = "/pages/user/memberInformation/update/ModifyPhone";
const ROUTE_MODIFY_EMAIL = "/pages/user/memberInformation/update/ModifyEmail";
const ROUTE_MODIFY_LOGIN_PASSWORD = "/pages/user/memberInformation/update/ModifyLoginPassword";
const ROUTE_MODIFY_WITHDRAW_PASSWORD = "/pages/user/memberInformation/update/ModifyWithdrawPassword";
const ROUTE_AGENCY = "/pages/user/agency/Agency";
const ROUTE_AGENT_DEPOT = "/pages/user/agency/AgentDepot";
const ROUTE_AGENT_TRANSFER_WITHDRAW = "/pages/user/agency/AgentTransferWithdraw";
const ROUTE_AGENCY_LINK = "/pages/user/agency/AgencyLink";
const ROUTE_MY_TEAM = "/pages/user/agency/MyTeam";
const ROUTE_LOWER_LEVEL_DEPOT = "/pages/user/agency/LowerLevelDepot";
const ROUTE_FRIEND_COUPON = "/pages/user/friendCoupon/FriendCoupon";
const ROUTE_FRIEND_COUPON_TERMS = "/pages/user/friendCoupon/FriendCouponTerms";
const ROUTE_FRIEND_COUPON_QR = "/pages/user/friendCoupon/FriendCouponQR";
const ROUTE_USER_COUPON = "/pages/user/userCoupon/UserCoupon";
const ROUTE_NOTICE_DETAILED = "/pages/home/NoticeDetailed";
const ROUTE_CHAT_LIST = "/pages/chat/ChatList";
const ROUTE_CHAT = "/pages/chat/Chat";
const APP_DOWNLOAD = "/pages/appdownload/AppDownload";
const FORGOT_LOGINNAME = "/pages/forgotLoginName/ForgotLoginName";
const BACKUP_API_PAGE = "/pages/backupAPIPage/backupapipage";
const RISK_NOTICE_POPUP_PAGE = "/pages/RiskNotice/RiskNotice";

export {
	ROUTE_LOGIN,
	ROUTE_REGISTER,
	ROUTE_FORGOT_PASSWORD,
	ROUTE_HOME,
	ROUTE_ALL_NEWS,
	ROUTE_TIME_BAO_DETAILS,
	ROUTE_NEWS_DETAILS,
	ROUTE_QUOTES,
	ROUTE_TIME_BAO,
	ROUTE_INCREASE_INFO,
	ROUTE_SEARCH_QUOTES,
	ROUTE_ACTIVITY_DETAIL,
	ROUTE_QUOTES_DETAILS,
	ROUTE_CAPITAL_ACCOUNT_DETAILS,
	ROUTE_CLOSED_CAPITAL_INFO,
	ROUTE_FUND_DETAILS,
	ROUTE_CAPITAL,
	ROUTE_FOUND_WINNER,
	ROUTE_ACTIVITY_LIST,
	ROUTE_ACCOUNT,
	ROUTE_PROTOCOL,
	ROUTE_RECHARGE,
	ROUTE_RECHARGE_INFO_1,
	ROUTE_RECHARGE_INFO_2,
	ROUTE_RECHARGE_INFO_3,
	ROUTE_WITHDRAW,
	ROUTE_KLINE,
	ROUTE_TRADING,
	ROUTE_TRADING_DIRECTION,
	ROUTE_ANNOUNCEMENT,
	ROUTE_ANNOUNCEMENT_DETAIL,
	ROUTE_MEMBER_INFORMATION,
	ROUTE_MEMBER_DETAILED_LOG,
	ROUTE_POSITION_INQUIRY,
	ROUTE_DEAL_INQUIRY,
	ROUTE_ENTRUST_INQUIRY,
	ROUTE_WITHDRAWAL_INQUIRY,
	ROUTE_ABOUT_US,
	ROUTE_RISK_CONTROL,
	ROUTE_MODIFY_NICKNAME,
	ROUTE_MODIFY_REALNAME,
	ROUTE_MODIFY_BANK,
	ROUTE_MODIFY_PHONE,
	ROUTE_MODIFY_EMAIL,
	ROUTE_MODIFY_LOGIN_PASSWORD,
	ROUTE_MODIFY_WITHDRAW_PASSWORD,
	ROUTE_AGENCY,
	ROUTE_AGENT_DEPOT,
	ROUTE_AGENT_TRANSFER_WITHDRAW,
	ROUTE_AGENCY_LINK,
	ROUTE_MY_TEAM,
	ROUTE_LOWER_LEVEL_DEPOT,
	ROUTE_FRIEND_COUPON,
	ROUTE_FRIEND_COUPON_TERMS,
	ROUTE_FRIEND_COUPON_QR,
	ROUTE_USER_COUPON,
	ROUTE_NOTICE_DETAILED,
	ROUTE_CHAT_LIST,
	ROUTE_CHAT,
	APP_DOWNLOAD,
	FORGOT_LOGINNAME,
	BACKUP_API_PAGE,
	RISK_NOTICE_POPUP_PAGE
};